// ── ตัวจับเวลา debug — ดูได้จาก Console (F12) ตอนใช้งานแอปจริง ─────────────
// ใช้เพื่อหาว่าขั้นตอนไหนช้า ไม่กระทบการทำงานจริงของแอป
export function perfMark(label) {
  const start = performance.now();
  return (extra = "") => {
    const ms = Math.round(performance.now() - start);
    const tag = ms >= 2000 ? "[SLOW]" : ms >= 800 ? "[WARN]" : "[ OK ]";
    // eslint-disable-next-line no-console
    console.log(`${tag} [เวลาที่ใช้] ${label}: ${ms}ms${extra ? " — " + extra : ""}`);
  };
}
